import $ from "jquery";
import React, { useEffect, useState } from 'react';
import Toastr from 'toastr';
import SessionManager from './../routes/SessionManager';
import logo from './../assets/img/sitesupt-ondemand.svg';
import Loading from "../components/Loading";
import livePic from "../assets/img/construction.jpg";
import bootbox from 'bootbox';

function Login() {

    var sessionManager = new SessionManager();
    var userData = sessionManager.readCookie('user', false);
    var ssoData = sessionManager.readCookie('sso', false);

    const [user_login, setUserLogin] = useState(userData ? userData.user_login : '');
    const [user_pass, setUserPass] = useState('');
    const [authenticating, setAuthenticating] = useState(ssoData ? true : false);

    let session_exists = userData ? true : false;
    let sso_loading = ssoData ? true : false;

    const handleEnterKeyPress = (e) => {
        if (e.keyCode && e.keyCode === 13) {
            $('#login-btn').trigger('click');
        }
    }

    const positionUIElements = () => {
        let whPerc = ($(window).width() <= 768 && $(window).width() < $(window).height()) ? 0.66 : 1;
        $('.login-box').css({ height: $(window).height() * whPerc });
        $('.live-pic').css({ height: $(window).height() * whPerc });
        $('.login-box-content').css({ marginTop: ($(window).innerHeight() * whPerc * 0.5) - ($('.login-box-content').height() * 0.5) });
    }

    document.querySelector('body').onkeypress = handleEnterKeyPress;
    window.onresize = positionUIElements;

    const browser = () => {
        let us = navigator.userAgent.toLowerCase();

        if (document.documentMode === true) {
            return "IE"
        } else if (us.indexOf('opr') > -1) {
            return "Opera"
        } else if (us.indexOf('edg') > -1) {
            return "edge"
        } else if (us.indexOf('safari') > -1 && !!window.safari === true) {
            return "safari"
        } else if (us.indexOf('chrome') > -1 || us.indexOf('crios') > -1 || !!window.chrome === true) {
            return "chrome"
        } else if (us.indexOf('firefox') > -1 || us.indexOf('fxios') > -1 || us.indexOf('focus') > -1) {
            return "firefox"
        } else {
            return "not detected"
        }
    }

    const device = () => {
        /* Storing user's device details in a variable*/
        let details = navigator.userAgent;

        /* Creating a regular expression containing some mobile devices keywords to search it in details string*/
        let regexp = /android|iphone|kindle|ipad/i;

        /* Using test() method to search regexp in details it returns boolean value*/
        let isMobileDevice = regexp.test(details);

        if (isMobileDevice) {
            return "mobile"
        } else {
            return "desktop"
        }
    }

    const deviceDetails = () => {
        let userAgent = (navigator.userAgent).toString().toLowerCase();

        const device = {
            Kindle: /kindle/.test(userAgent),
            iPad: /ipad/.test(userAgent),
            iPhone: /iphone/.test(userAgent),
            Android: /android/.test(userAgent),
            Windows: /windows/.test(userAgent),
            MacOS: /mac os/.test(userAgent),
            Ubuntu: /ubuntu/.test(userAgent)
        }

        let device_type = '';
        for (let d in device)
            if (device[d])
                device_type = d;

        let regexp = /android|iphone|kindle|ipad/i;
        let isMobileDevice = regexp.test(userAgent);

        if (isMobileDevice) {
            return { device: 'Mobile Device', device_type: device_type }
        } else {
            return { device: 'Laptop/Desktop', device_type: device_type }
        }
    }


    const redirectAfterLogin = (userData) => {
        var sessionManager = new SessionManager();
        if (!session_exists) {
            userData.default_dashboard = userData.defaultView;
            delete userData.page_queue;

            if (userData.user_role === 209)
                userData.default_dashboard = "Executive Dashboard";

            sessionManager.storeCookie(
                'user',
                userData
            );

        } else {
            userData = sessionManager.readCookie('user', null);
        }

        let goto = userData.default_dashboard === "Executive Dashboard" ? '/dashboard-exec' : userData.default_dashboard === "Map View" ? '/map-view' : userData.default_dashboard === "Site Map" ? '/sitemap' : '/dashboard';
        if (userData.site_locations === undefined || userData.site_locations.length === 0)
            goto = '/message';

        switch (userData.user_role) {
            case 2:
            case 99:
                if (userData.site_locations === undefined || userData.site_locations.length === 0)
                    goto = '/message';
                break;

            case 4:
            case 98:
                goto = '/owners-portal';
                break;

            default:
                break;
        }

        if (window.location.search.indexOf('redirectUrl') !== -1) {
            goto = window.location.search.replace('?redirectUrl=', '');
        }

        const history = require("history").createBrowserHistory({ forceRefresh: true });
        history.push(goto);
    }

    const fetchAccessGroupDetails = async (user, groupIds) => {
        return new Promise((resolve, reject) => {
            let advanced_filter = [];
            console.log('groupIds', groupIds);
            for (let g of groupIds)
                advanced_filter.push({ attribute: 'group_id', value: g + "", operator: '=', join_by: 'or' });

            let data = {
                "source": "M",
                "criteria": { "from": 0, "size": 1000, advanced_filter: JSON.stringify(advanced_filter) },
                "user_login": user.user_login,
                "user_token": user.user_token,
                "user_type": "user"
            };

            $.ajax({
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/dom_group/fetch',
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }).then(
                res => {
                    if (res.status && res.status.code === 200) {
                        resolve(res.data.records);
                    } else {
                        resolve([]);
                    }
                },
                res => {
                    resolve([]);
                }
            );
        });
    }


    const fetchAdminSites = async (user, isSuper = false) => {
        return new Promise((resolve, reject) => {
            let criteria = { "from": 0, "size": 1000 };
            criteria.advanced_filter = [];

            if (!isSuper) {
                if (user.user_sites)
                    criteria.advanced_filter.push({ attribute: 'site_id', virtual_column: true, value: user.user_sites, operator: 'in', join_by: 'or' });

                if (criteria.customer_id)
                    criteria.advanced_filter.push({ attribute: 'customer_id', value: user.customer_id, operator: '=', join_by: 'or' });
            }

            if (criteria.advanced_filter.length === 0)
                delete criteria.advanced_filter;
            else
                criteria.advanced_filter = JSON.stringify(criteria.advanced_filter);

            // if (!isSuper) {
            //     criteria.customer_id = user.customer_id;
            // };

            $.ajax(
                {
                    url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/site/fetch',
                    type: 'POST',
                    contentType: "application/json; charset=utf-8",
                    data: JSON.stringify({
                        "criteria": criteria,
                        "user_type": "user",
                        user_login: user.user_login,
                        user_token: user.user_token,
                        app_name: 'SITESUPT'
                    }),
                    dataType: "json"
                }
            ).then((res) => {
                if (res && res.status.code === 200) {
                    resolve(res.data.records);
                }
            }, (err) => {
                resolve([]);
            });
        })
    }

    const populateUserObject = async (userData) => {
        let hasAllSitesAccess = [99, 98].includes(userData.user_role);
        let siteRecords = await fetchAdminSites(userData, hasAllSitesAccess);
        if (siteRecords && siteRecords.length > 0) {
            let site_locations = [];

            let sites = [];
            let site_default;
            for (let s of siteRecords) {
                if (!hasAllSitesAccess && userData.user_sites && !userData.user_sites.includes(s.site_id))
                    continue;

                if (hasAllSitesAccess || (userData.permissions && userData.permissions.includes('SITESUPT-UI-ALLOW-INACTIVE-SITES')) || s.record.site_state.trim().toUpperCase() !== 'INACTIVE') {
                    sites.push(s.site_id);
                    site_locations.push(s.record);

                    if (s.site_id === userData.site_id)
                        site_default = s.record;
                }
            }

            site_locations = site_locations.sort((a, b) => {
                let x = a.site_name;
                let y = b.site_name;
                return ((x > y) - (y > x));
            });

            userData.user_sites = sites;
            userData.site_locations = site_locations;
            userData.site_selected = site_default || site_locations[0];
        }
    }

    const captureUserVisit = (user, source) => {
        let site_info = user.site_selected ? user.site_selected : {};
        let data = {
            user_login: user.user_login,
            user_token: user.user_token,
            operation: "create",
            site_id: '0000000000000',
            form_input: {
                "object": "user_audit",
                "attributes": ["customer_id", "site_id", "object_type", "after_modify", "modified_by"],
                "records": JSON.stringify([[user.customer_id, site_info.site_id, "user_visits", JSON.stringify({ user: user.user_login, site_id: site_info.site_id, site_name: site_info.site_name, customer_id: user.customer_id, source: source, ...deviceDetails() }), user.user_login]])
            }
        };

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/data-explorer',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        );
    }

    const postAuthentication = async (res) => {

        var sessionManager = new SessionManager();
        sessionManager.storeCookie('user_activity', { 'login_timestamp': new Date().getTime(), 'browser': browser(), 'device': device(), 'user_login': user_login });
        $('#spinner').toggleClass("d-none");

        var userData = res.data;

        if (userData.user_state && userData.user_state === "Inactive") {
            Toastr.error('You do not have the necessary permissions to login. Please reach out to your Supt or SiteKick Support.');
            setAuthenticating(false);
            return;
        }

        Toastr.success('Welcome on SiteSupt OnDemand', 'Welcome !');

        let deleteAtts = ['site_selected', 'zones', 'site_locations'];
        for (let att of deleteAtts) {
            delete userData[att];
        }

        if (userData && userData.user_sites && userData.user_sites.length > 0) {
            userData.user_sites = [...new Set(userData.user_sites)];

            if (userData.site_id === "0" || userData.site_id === undefined || userData.site_id === 0) {
                userData.site_id = userData.user_sites[0];
            }
        }

        let permissionsExtra = [];
        switch (userData.user_role) {
            case 1:
                if (userData.access_groups) {
                    let groups = [];
                    for (let g in userData.access_groups) {
                        console.log(g + ' - ', userData.access_groups[g]);
                        let arr = [];
                        try {
                            arr = JSON.parse(userData.access_groups[g])
                        } catch (e) { }
                        groups = groups.concat(arr);
                    }

                    try {
                        let permissions = await fetchAccessGroupDetails(userData, groups);
                        if (permissions && permissions.length > 0) {
                            for (let p of permissions) {
                                if (p.record.group_description) {
                                    let gDesc = p.record.group_description;
                                    switch (gDesc.type) {
                                        case 'permission':
                                            permissionsExtra.push(gDesc.name);
                                            break;

                                        case 'location':
                                            if (!userData.user_zones)
                                                userData.user_zones = {};

                                            if (!userData.user_zones[gDesc.site_id])
                                                userData.user_zones[gDesc.site_id] = [];

                                            userData.user_zones[gDesc.site_id].push(p.record.group_permission);
                                            break;

                                        default:
                                            break;
                                    }
                                }
                            }
                        }

                        delete userData.access_groups;
                    } catch (e) {
                        console.log(e);
                    }
                }
                break;

            default:
                break;
        }

        if (userData.permissions) {
            userData.permissions = userData.permissions.map(p => p.role_permission);
        }

        await populateUserObject(userData);

        if (!session_exists || (user_login !== userData.user_login)) {
            captureUserVisit(userData, sso_loading ? 'Procore' : 'SiteSupt');
        }

        if (!userData.user_sites) {
            userData.user_sites = [userData.site_id];
        }

        let hasAllSitesAccess = [99, 98].includes(userData.user_role);
        if (!hasAllSitesAccess && userData.site_locations.length === 0) {
            Toastr.error('You don\'t have access to any sites. Please reach out to your Supt or SiteKick Support.');
            setAuthenticating(false);
            return;
        }

        sessionManager.removeCookie('sso');
        setTimeout(function () {
            redirectAfterLogin(userData);
        }, 1000);
    }

    if (ssoData) {
        postAuthentication({ data: ssoData, sso_loading: true });
    }

    const triggerPasswordExpiry = (userData) => {
        let user_login = userData.user_login;
        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/reset-pwd-challenge',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify({
                    operation: 'trigger-password-expiry',
                    form_input: {
                        user_login: user_login
                    }
                }),
                dataType: "json"
            }
        ).then((res) => {
            if (res && res.status) {
                switch (res.status.code) {
                    case 200:
                        bootbox.alert('Your password has been expired. Check your email for the verification code to renew it.', () => {
                            window.location = "/renew-password?username=" + user_login;
                        })
                        break;

                    default:
                        // setTimeout(function () {
                        //     redirectAfterLogin(userData);
                        // }, 1000);
                        break;
                }
            } else {
                // setTimeout(function () {
                //     redirectAfterLogin(userData);
                // }, 1000);
            }
        }, (err) => {
            // setTimeout(function () {
            //     redirectAfterLogin(userData);
            // }, 1000);
        });
    }

    useEffect(() => {
        positionUIElements();
    }, []);

    const handleInputChange = (event) => {
        const target = event.target;

        switch (target.name) {
            case "user_login":
                setUserLogin(target.value);
                break;
            case "user_pass":
                setUserPass(target.value);
                break;
            default:
                break;
        }
    }

    const handleLogin = (e) => {
        if (user_login === '' || user_pass === '') {
            Toastr.error('Missing credentials', 'Invalid Input ...');
            return;
        }
        $('#login-btn').html('Authenticating ...').attr('disabled', true);
        $('#spinner').toggleClass("d-none");

        setAuthenticating(true);

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/auth/authenticate',
                type: 'GET',
                headers: {
                    user_login: (user_login).toLowerCase(),
                    user_pass: user_pass,
                    app_name: 'SITESUPT'
                },
                dataType: "json"
            }
        ).then(async (res) => {
            if (res.status && res.status.code === 200) {
                let userData = res.data;
                // Greater than 90 days, force password change.
                if (userData && userData.user_email1 && (!userData.last_renew_ts || (new Date().valueOf() - userData.last_renew_ts) > (86400000 * 90))) {
                    triggerPasswordExpiry(userData);
                } else {
                    postAuthentication(res);
                }
            } else {
                if (res.status && res.status.code === 401) {
                    Toastr.error('Please try again ...', res.status.message || 'Invalid credentials');
                }
            }
            setAuthenticating(false);
        },
        ).fail(function (jqXHR, textStatus, errorThrown) {

            if (jqXHR.responseJSON && jqXHR.responseJSON.status && jqXHR.responseJSON.status.code === 401) {
                Toastr.error('Please try again ...', jqXHR.responseJSON.message || 'Invalid credentials');
            }

            if (jqXHR.status === 0) {
                Toastr.info(
                    'Posssible Reasons: <br />  &nbsp;1. Invalid credentials with spl chars. <br/>     &nbsp;2. Internet Connectivity issues.',
                    '<div class="mb-2">Request Failed</div>',
                    { messageClass: 'text-white p-0' }
                );
            }
            setAuthenticating(false);
        });

        return false;
    }

    return (
        <React.Fragment>
            <div id="loginContainer" className="container-fluid p-0 bg-white">
                <div className="row no-gutters">
                    <div className="col-md-6 col-xs-12 p-2 login-box">
                        <div className="login-box-content">
                            <div className="text-center">
                                <span className="logo-font font-size-16 text-app-2 strong">
                                    <img className="pb-1 " src={logo} alt="logo" style={{ width: "190px", marginRight: "10px" }} />
                                </span>
                            </div>
                            <br /><br />

                            {!sso_loading ?
                                <>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <label className="py-0 my-0 text-app-2 font-size-16">Username </label>
                                            <input name="user_login" className="form-control border-app w-100-perc" readOnly={session_exists} autoFocus={!session_exists} type="username" value={user_login} onChange={handleInputChange} autoComplete="off" placeholder="User Name" />
                                        </div>
                                    </div>
                                    {(!session_exists ?
                                        <React.Fragment>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <label className="py-0 my-0 mt-3 text-app-2 font-size-16">Password</label>
                                                    <input name="user_pass" className="form-control w-100-perc" type="password" value={user_pass} onChange={handleInputChange} autoComplete="off" placeholder="Password" />
                                                </div>
                                            </div>
                                            <div className="row mt-4">
                                                <div className="col text-right">
                                                    {!authenticating ?
                                                        <React.Fragment>
                                                            <a className="btn btn-sm btn-link no-bg" href="/forgot-password" alt="#">Forgot password?</a>
                                                            <button id="login-btn" type="button" className="btn btn-md btn-app-2" onClick={(e) => handleLogin(e)}>Log In</button>
                                                        </React.Fragment> :
                                                        <Loading>Authenticating ...</Loading>
                                                    }
                                                </div>
                                            </div>
                                        </React.Fragment> :
                                        <div className="row">
                                            <div className="col-12">
                                                <button id="login-btn" type="button" className="btn btn-md btn-app-2 mt-4 pull-right" onClick={(e) => redirectAfterLogin()} >Go To Dashboard</button>
                                            </div>
                                        </div>
                                    )}
                                </> :
                                <Loading>Loading ... SiteSupt OnDemand </Loading>
                            }
                            <div className="text-app-2 font-size-md16-xs14 mt-1 col-12">Eliminating Paperwork <br />So you can get back to building.</div>
                        </div>
                    </div>
                    <img alt="SiteSupt OnDemand" src={livePic} className="col-md-6 col-xs-12 box-shadow-top" />
                </div>
            </div>
        </React.Fragment>
    );
}

export default Login;